import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const WidgetService = {
  getList: async ({ page = 1, pageSize = 10, isOnshore, name }) => {
    try {
      const params = new URLSearchParams({
        page: String(page),
        pageSize: String(pageSize),
        ...(isOnshore !== null && isOnshore !== undefined && { isOnshore }),
        ...(name !== null && name !== undefined && { name: String(name) }),
      });

      const response = await apiService.get(`/widgets?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return { data: [], totalRecords: 0 }; // fallback so UI doesn't break
    }
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/widgets/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  create: async (data) => {
    const response = await apiService.post("/widgets", data);
    return response.data;
  },

  getdetail: async (id) => {
    const response = await apiService.get(`/widgets/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/widgets/${id}`);
    return response.data;
  },
};

export default WidgetService;
